import React from 'react';
import getDataRange from '../../helpers/getDataRange';
import DeviceDropdown from '../../modules/DeviceDropdown';
// import FilterDropdown from '../../modules/FilterDropdown';
import { isTrue } from '../../helpers/isTrue';
import DateRangePickerContainer from '../Modals/DatePicker';

const changeDates = new Event('changeDates');

class FilterOptions extends React.Component {
    constructor(props) {
        super();

        let label = props.default.label || 'Select';

        this.onChange = this.onChange.bind(this);
        this.updateSelect = this.updateSelect.bind(this);
        this.updateFilter = this.updateFilter.bind(this);
        this.handleMoodeChange = this.handleMoodeChange.bind(this);

        const isDark = JSON.parse(localStorage.getItem('dark-mode'));
        this.state = {
            label: label,
            open: false,
            device: window?.filters?.filters?.device ?? 'MOBILE',
            isDark: !!isDark,
            dateFilterValue: window?.filters?.filters?.dates?.id ?? 'last_week',
        };
    }

    async componentDidMount() {
        document.addEventListener('changeMoodEvent', this.handleMoodeChange);
    }
    componentWillUnmount() {
        document.removeEventListener('changeMoodEvent', this.handleMoodeChange);
    }

    handleMoodeChange() {
        const isDark = JSON.parse(localStorage.getItem('dark-mode'));
        this.setState({ isDark });
    }

    onChange(choice) {
        this.setState({
            dateFilterValue: choice.id === 'custom' ? 'custom' : choice.value,
            label: choice.label,
            open: false,
        });
        const choiceValue = getDataRange(choice);

        setTimeout(() => {
            document.dispatchEvent(changeDates);
        }, 1000);
        const selectedChoice = { ...choice, values: choiceValue };
        return (
            (choice.onSelect &&
                choice.onSelect(this.props.name, selectedChoice.value, selectedChoice)) ||
            (this.props.onChange && this.props.onChange(this.props.name, selectedChoice))
        );
    }

    updateSelect(device) {
        this.setState({ device });
        window.filters.update({ device });
    }

    updateFilter(choice) {
        this.onChange(choice);
    }

    render() {
        return (
            <div
                className={(this.props.className || '') + 'list-group-item-action'}
                style={{ marginBottom: '10px' }}
            >
                <div className="show d-flex filter-options align-items-center" aria-labelledby="">
                    {this.props.gsc_report && (
                        <div
                            className="search-filters"
                            style={{ maxWidth: '300px', margin: '0px 10px 10px 0px' }}
                        >
                            <DeviceDropdown
                                device={this.state.device}
                                updateSelect={this.updateSelect}
                                padding={'2px 5px'}
                                show_all={this.props.show_all}
                                isDark={this.state.isDark}
                            />
                        </div>
                    )}
                    {/* {!isTrue(this.props.dont_show_date_filter) && (
                        <div style={{ maxWidth: '300px', margin: '0px 10px 10px 0px' }}>
                            <FilterDropdown
                                updateSelect={this.updateFilter}
                                options={this.props.choices}
                                dateFilterValue={this.state.dateFilterValue}
                                gsc_report={this.props.gsc_report}
                            />
                        </div>
                    )} */}
                    {/* <DateRangePicker /> */}
                    {!isTrue(this.props.dont_show_date_filter) && (
                        <DateRangePickerContainer
                            updateSelect={this.updateFilter}
                            options={this.props.choices}
                            dateFilterValue={this.state.dateFilterValue}
                            gsc_report={this.props.gsc_report || this.props.select_by_week}
                            is_from_tools={this.props.is_from_tools}
                            is_from_ai_tracking={this.props.is_from_ai_tracking}
                        />
                    )}
                </div>
            </div>
        );
    }
}

export default FilterOptions;
